<template lang="pug">
  app-modal(
    :titulo="titulo",
    v-if="showModal && !this.analiseSemDespacho"
    :width="1000"
    :height="800"
    @closeModal="closeModal"
  )
    template(slot="body" v-if="isBahia")
      el-carousel(v-if="responseDocumentos" indicator-position='outside' :loop="false", :autoplay="false", @change="updateIndex").body
        el-carousel-item(v-for='(item, index) in responseDocumentos' :key='index').body
          object(:data="'data:application/pdf;base64,' + item.base64" type='application/pdf' width='100%' height='70%')
          el-row.center
            el-checkbox(v-if="!isBahia", @change="addAssinatura(item)" label='Assinar' border='')
          el-row
            app-radios-tramitacao(
              v-for='(item) in processosTramitacao'
              :key="index"
              :radios="item.radios"
              :isDecisao="isDecisao"
              @changeRadio="changeRadio"
              :radioInicial="null",
            )
      el-row
        div(v-if="mostrarCampoSenha")
          app-label.magin(label="Senha:", :required="true")
          el-input.input(type="password", v-model="senha")

    template(slot="body" v-if="!isBahia")
      el-carousel(v-if="responseDocumentos" indicator-position='outside' :loop="false", :autoplay="false").body
        el-carousel-item(v-for='(item, index) in responseDocumentos' :key='index').body
          object(:data="'data:application/pdf;base64,' + item.base64" type='application/pdf' width='100%' height='70%')
          el-row.center
            el-checkbox(@change="addAssinatura(item)" label='Assinar' border='')
      el-row
        div
          app-label.magin(label="Senha:", :required="true")
          el-input.input(type="password", v-model="senha")
    template(slot="footer")
      app-utilizar-buttons(
        @cancel="closeModal",
        @confirm="save",
        :textModel="'assinar documentos'",
        :textButtonConfirm="'Assinar Documento(s)'"
      )
</template>

<script>
import axios from '@/utils/api'
import { mapActions } from 'vuex'
import AppUtilizarButtons from '../AppUtilizarButtons'
import AppSearchDespachos from '../AppSearchDespachos'
import AppModal from '@/components/AppModal'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppLabel from '@/components/AppLabel'
import AppRadiosTramitacao from '@/components/AppRadiosTramitacao.vue'

export default {

  components: {
    AppUtilizarButtons,
    AppSearchDespachos,
    AppModal,
    AppRadiosTramitacao,
    AppLabel
  },
  props: {
    tiposModelo: {
      type: Array,
      required: true
    },
    idsProcessos: {
      type: Array,
      required: false
    },
    showModal: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    analiseSemDespacho: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      selectedModelo: {},
      filtro: { parametro: '', tiposModelo: this.tiposModelo },
      isDecisao: false,
      modelos: [],
      processosTramitacao: [],
      responseDocumentos: [],
      idsProcessoAssinar: [],
      processosAssinar: [],
      senha: null,
      processos: null,
      radios: [],
      isBahia: null,
      acao: null,
      index: 0,
      acoesAlternada: []
    }
  },

  async created () {
    this.idsProcessos = this.idsProcessos.sort()
    this.isBahia = process.env.ESTADO === 'ba'
    this.processos = await this.tarefa({processo: this.idsProcessos[0]})
    this.processosAssinar = this.idsProcessos.map(idProcesso => ({id: idProcesso, acao: '', nomeAcao: ''}))
    this.radios = this.processos?.acoes
    this.processosTramitacao = [{
      radios: this.processos?.acoes
    }]
    axios(
      {
        method: 'POST',
        url: `publico/documentoAutenticavel/getDocumentosDespacho`,
        data: {idsProcesso: this.idsProcessos}
      }
    ).then(resp => {
      this.responseDocumentos = resp
    })
    if (!this.analiseSemDespacho) {
      const data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    } else {
      this.salvarSemMotivo()
    }
  },

  computed: {
    mostrarCampoSenha () {
      if (this.isBahia) {
        if (this.idsProcessoAssinar?.length) return true
        return false
      }
      return true
    }
  },

  methods: {
    ...mapActions({
      findByFiltroSelecao: 'modeloDespacho/findByFiltroSelecao',
      findByFiltroSelecaoAndProcesso: 'despacho/findByFiltroSelecaoAndProcesso',
      analiseConjuta: 'processo/analiseConjunta',
      tramitarComAcao: 'processo/tramitarComAcao',
      tarefa: 'processo/tarefa'
    }),
    changeRadio (value) {
      this.acao = value.acao
      this.acoesAlternada.push({
        idProcessos: this.idsProcessos[this.index],
        acao: value.acao
      })
      if (this.isBahia) {
        const { nome, valor } = this.processosTramitacao[0].radios.find(radio => radio.valor === value.acao)
        const processosAux = [...this.processosAssinar]
        processosAux[this.index] = {id: this.processosAssinar[this.index].id, nomeAcao: nome, acao: valor}
        this.processosAssinar = processosAux
        this.addAssinatura(this.responseDocumentos.find(doc => doc.idProcesso === this.processosAssinar[this.index].id))
      }
    },
    closeModal () {
      this.$emit('closeModal')
      if (!this.isBahia) {
        this.$emit('atualizarListagem')
      }
    },
    updateIndex (index = 0) {
      this.index = index
      this.tarefa({processo: this.idsProcessos[index]}).then((result) => {
        this.processos = result
        this.radios = this.processos?.acoes
        this.processosTramitacao = [{
          radios: this.processos?.acoes
        }]
      })
      this.acoesAlternada.push({
        idProcessos: this.idsProcessos[index],
        acao: this.acao
      })
    },
    checkValidacao () {
      // fazendo de forma diferente para a Bahia
      // de acordo com a regra agora na Bahia, caso tenha selecionado o Retornar setor em algum doc
      // Precisa tramita-lo sem precisar assinar o documento em questão
      // agora diferente disso, precisa assinar
      if (this.isBahia) {
        // Verifica se a ação selecionada é "Retornar setor"
        let retornarSetorSelecionado = this.acao === 'ENCAMINHAR.SISTEMA.NAJ.ENCAMINHAMENTO'

        if (this.senha === null && this.mostrarCampoSenha) {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, coloque a senha.')
          return false
        }

        // Se o botão "Retornar setor" estiver selecionado, não é necessário assinar
        if (retornarSetorSelecionado && this.senha?.length) {
          return true
        }

        // Se algum documento não tiver tramitação selecionada, mostra uma mensagem de erro
        if (this.processosAssinar.find(processo => !processo.acao)) {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha para onde deseja encaminhar os processos.')
          return false
        }

        // Se tudo estiver válido, retorna verdadeiro
        return true
      } else {
        const valido = this.idsProcessoAssinar.length > 0
        if (!valido) {
          this.showNotificacao(this.$messages.TIPO_ERROR, this.$messages.TITULO_WARNING, 'Por favor, selecione um modelo.')
          return false
        }
        return true
      }
    },
    async save () {
      if (!this.checkValidacao()) {
        return
      }
      this.confirmBox(this.$messages.ENCAMINHAR_DADOS, this.$messages.TITULO_ANALISE,
        async () => {
          axios({
            method: 'POST',
            url: 'assinatura/assinar/documentoDespacho',
            data: {idProcessosParaAssinar: this.idsProcessoAssinar, senha: this.senha, idsProcessos: this.idsProcessos, acoes: this.acoesAlternada}
          }).then(resp => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'Processo(s) analisado(s) com sucesso')
            this.senha = null
          }).finally(() => {
            this.closeModal()
          })
        },
        () => {
        })
    },

    async search (param) {
      this.filtro.parametro = param
      let data = await this.findByFiltroSelecao(this.filtro)
      this.modelos = data
    },
    clear () {

    },

    selectModelo (id) {
      if (this.selectedModelo.id === id) {
        this.selectedModelo = {}
      } else {
        this.selectedModelo = this.modelos.find(x => x.id === id)
      }
    },

    addAssinatura (t) {
      if (this.isBahia) {
        const processo = this.processosAssinar.find(processo => processo.id === t.idProcesso)
        if (!this.idsProcessoAssinar.includes(t.idProcesso) && !processo.nomeAcao.toUpperCase().includes('RETORNAR')) {
          this.idsProcessoAssinar = [...this.idsProcessoAssinar, t.idProcesso]
        } else if (processo.nomeAcao.toUpperCase().includes('RETORNAR')) {
          this.idsProcessoAssinar = this.idsProcessoAssinar.filter(elemento => elemento !== t.idProcesso)
        }
      } else {
        this.idsProcessoAssinar = this.idsProcessoAssinar.includes(t.idProcesso)
          ? this.idsProcessoAssinar.filter(elemento => elemento !== t.idProcesso) : [...this.idsProcessoAssinar, t.idProcesso]
      }
    }
  }
}

</script>

<style scoped lang="scss">
.center {
  text-align: center;
  margin-top: 20px !important;

}
p.message {
  width: 80%;
  margin: 0 auto;
}
.copy-paste-from-web {
  border-color: currentcolor;
  outline-color: currentcolor;
  background-color: rgba(25, 36, 49, 0.11);
  color: rgb(232, 230, 227);
  right: 16px;
}
.center {
  margin-top: 40px !important;
  text-align: center;
}

.item {
  margin: 5px;
  width: 310px;
}

.el-card {
  max-width: 100%;
  height: 350px;
  font-size: 12px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.container-modelo {
  padding-top: 22px;
  display: flex;
  flex-wrap: wrap;
}
.descricao {
  font-weight: bold;
  font-size: 16px;
}
.no-visible {
  display: none;
}

.border-bottom {
  padding-bottom: 10px;
  border-bottom: solid 1px #A7B2BA;
}

.active {
  background: rgb(223, 223, 223) !important;
}

.body {
  height: 500px;
}

.center {
  display: flex;
  flex-direction: 'row';
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalAssinaturaConjunta.vue